import { handleRequest } from "../utilities/requestHandler";

// Pagination is OPT-IN: called with no arguments this returns the full list,
// which is what the dropdown/filter/analytics callers across the app expect.
// Pass a params object and the server returns { rows, row_count, ... } instead.
export const getMachines = (options) => {
    if (!options) return handleRequest("get", "/machines");
    const { page = 0, pageSize = 10, search = "", sortField, sortOrder } = options;
    const params = new URLSearchParams({ page, pageSize });
    if (search) params.set("search", search);
    if (sortField) params.set("sortField", sortField);
    if (sortOrder) params.set("sortOrder", sortOrder);
    return handleRequest("get", `/machines?${params.toString()}`);
};

export const uploadMachineAssets = (formData) =>
    handleRequest("post", "/machines/upload-assets", formData, { 'Content-Type': 'multipart/form-data' });

export const updateMachine = (machineId, machineData) =>
    handleRequest("put", `/machines/${machineId}`, machineData);

export const createMachine = (machineData) =>
    handleRequest("post", "/machines/create", machineData);

export const deleteMachines = (ids) =>
    handleRequest("post", "/machines/delete", { ids });